export const isValidCoordinate = (lat: any, lng: any): boolean => {
  if (lat === undefined || lat === null || lat === '' ||
      lng === undefined || lng === null || lng === '') {
    return false;
  }
  const latNum = Number(lat);
  const lngNum = Number(lng);
  if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return false;
  if (Math.abs(latNum) > 90 || Math.abs(lngNum) > 180) return false;
  if (latNum === 0 && lngNum === 0) return false;
  return true;
};

export const describeInvalidPoint = (point: any): string => {
  const typeLabel = point.isLGI ? 'Legislator' : point.isCGI ? 'County Official' : 'Mayor';
  const name = point.mayors_name || point.county_officials_name || point.legislators_name || '(no name)';
  const location = point.isLGI
    ? (point.home_office_address || `${point.district || ''}, ${point.state || ''}`)
    : point.isCGI
      ? `${point.county || ''}, ${point.state || ''}`
      : `${point.city || ''}, ${point.state || ''}`;
  return `  ${typeLabel} "${name}" — ${location} — lat=${point.latitude} lng=${point.longitude}`;
};
